import React  from 'react'
import {Button} from 'react-bootstrap';
import {Link} from 'react-scroll';

 function BlockFirst() {
    
    return (
     <div>
        <div class="row pirmasblokas sonai ">
          <div className="pav mb-5"><p> Interneto svetainių kūrimas: nuo domeno pirkimo, turinio valdymo sistemos paruošimo iki apmokymo naudotis. SEO ir e-marketingo paslaugos.</p></div>
          <div class="col-md-12 text-center ">
            <Link Link activeClass="active" to="kontaktai" spy={true} smooth={true}>
              <Button className="button"  variant="amber"  active type="submit">SUSISIEKITE!</Button>
            </Link>
          </div>
        </div>
      </div>
    )
}
export default BlockFirst